export interface IPromiseManager {
  register<Response>(id: string): Promise<Response>
  resolve(id: string, data: unknown): void
  reject(id: string, data: unknown): void
}

interface IPromiseItem {
  id: string
  resolve: (...args: any[]) => void
  reject: (error: Error) => void
}

/**
 * PromiseManager keeps track of registred promises.
 * It can register a promise, and later resolve or reject it.
 */
export class PromiseManager implements IPromiseManager {
  private promiseList: { [key: string]: IPromiseItem } = {}

  public register<Response>(id: string): Promise<Response> {
    return new Promise((resolve, reject): void | Error => {
      if (this.promiseList[id] !== undefined) {
        return reject('PromiseManager: A promise with that ID already exist')
      }
      this.promiseList[id] = { id, resolve, reject }
    })
  }

  public resolve(id: string, data: unknown): void {
    const result = this.getById(id)
    if (result instanceof Error) {
      throw result
    }
    result.resolve(data)
    this.remove(id)
  }

  public reject(id: string, data: Error): void {
    const result = this.getById(id)
    if (result instanceof Error) {
      throw result
    }

    result.reject(data)
    this.remove(id)
  }

  private getById(id: string): IPromiseItem | Error {
    const promise = this.promiseList[id]
    if (!promise) {
      return new Error('PromiseManager: Promise ID does not exist')
    }

    return promise
  }

  private remove(id: string): void {
    delete this.promiseList[id]
  }
}
